module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('icon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }), _vm._v(" " + _vm._s(_vm.text))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fdb6ba8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/Loading.vue
// module id = 1538
// module chunks = 2